import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { BsEnvelope } from 'react-icons/bs'
import { Oval } from 'react-loader-spinner'
import { ToastContainer, toast } from 'react-toastify'
import "react-toastify/dist/ReactToastify.css"

import auth from '../../../redux/actions/auth'
import { LOGIN_PATH } from '../../../routes/navigation/navigation_paths'
import { FRONTEND_ROUTE } from '../../../routes/api/api_routes'

import bakeli from '../../../images/bakeli-group.jpeg'
import logo_bakeli from '../../../images/training.png'
import './style.css'

const ResetPassword = () => {
    const [formData, setFormData] = useState({
        email: "",
        password: ""
    })

    const navigate = useNavigate()
    const [requestSent, setRequestSent] = useState(false)
    const [loading, setLoading] = useState(false)
    const { email, password } = formData

    const onChange = e => setFormData({ ...formData, [e.target.name]: e.target.value })

    const onSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await auth.reset_password(email);   // ← on attend
            setRequestSent(true);
            notify();
        } catch (err) {
            console.error(err);
            toast.error("Impossible d’envoyer l’email de réinitialisation");
        } finally {
            setLoading(false);
        }
     };


    const notify = () => {
        toast('Un message a été envoyé sur votre email', {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
        })
    }

    /*useEffect(()=>{
        setTimeout(()=>{
            if (requestSent){
              window.location.replace(`${FRONTEND_ROUTE}/login`);
            }
        },4000)
       },[requestSent])*/


    return (
        <div className='login'>
            <div className='login_image_part'>
                <img src={bakeli} style={{ width: '100%', height: '100%', objectFit: "cover" }} />
   
            </div>

            <div className='login__body'>
                <div className='intitule'>
                    <img src={logo_bakeli} style={{ width: "50px", height: "50px" }} />
                    <div className='text'>
                        <h1>BAKELI TRAINING</h1>
                        <p>Training the best tech talent in Africa</p>
                    </div>
                </div>
                <div className="box">
                    <span className="borderLine"></span>
                    <form onSubmit={onSubmit} className='formulaire'>
                        <h2>Réinitialiser le mot de passe</h2>

                        <div className="inputBox">
                            <input
                                type="email"
                                name="email"
                                value={email}
                                onChange={onChange}
                                required
                            />
                            <span>Email</span>
                            <button type='button' disabled><BsEnvelope /></button>
                            <i></i>
                        </div>

                        <button type="submit" className='button_form' disabled={loading}>
                            Réinitialiser
                        </button>
                        <h6 className="form-footer">
                            Retour à la <a href={LOGIN_PATH} className='a a_signup'>connexion</a>
                        </h6>

                    </form>

                    {loading && (
                        <div className='loading'>
                            <Oval
                                height={40}
                                width={40}
                                color="#ffffff"
                                wrapperStyle={{}}
                                wrapperClass=""
                                visible={true}
                                ariaLabel='oval-loading'
                                secondaryColor="#000814"
                                strokeWidth={4}
                                strokeWidthSecondary={2}
                            />
                        </div>
                    )}
                </div>
            </div>

            <ToastContainer
                position="top-right"
                autoClose={5000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
                theme="colored"
            />
        </div>
    )
}

export default ResetPassword;